import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, HostListener, Inject, PLATFORM_ID } from '@angular/core';
import { LocationService } from '../../services/api/location/location.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment';
import { SwiperComponent } from 'swiper/angular';
import { BenefitsService } from 'src/app/services/api/benefits/benefits.service';
import { SliderService } from 'src/app/services/api/sliders/slider.service';
import SwiperCore, { SwiperOptions, Navigation, Pagination, Swiper }  from 'swiper';
import { Branch } from 'src/app/interfaces/branch/branch.interface';
import { isPlatformBrowser } from '@angular/common';

SwiperCore.use([Pagination]);

declare var google: any;

@Component({
  selector: 'app-shell-app',
  templateUrl: './shell-app.component.html',
  styleUrls: ['./shell-app.component.scss'],
})
export class ShellAppComponent implements OnInit, AfterViewInit {
  @ViewChild('swiperHero', { static: false }) swiperHero?: SwiperComponent;

  @ViewChild('swiperHeroMobile', { static: false }) swiperHeroMobile?: SwiperComponent;
  @ViewChild('mapContainer', { static: false }) gmap: ElementRef;
  @ViewChild('videoDesktop', { static: false }) videoDesktop!: ElementRef<HTMLVideoElement>;
  @ViewChild('videoMobile', { static: false }) videoMobile!: ElementRef<HTMLVideoElement>;

  @ViewChild('mapContainerMobile', { static: false }) gmapMobile: ElementRef;
  @HostListener('window:resize', ['$event'])

  locationsUrl = `${environment.API_URL}/Shellbox_Location`;

  loading = true;
  benefits: any = [];
  locations: any = [];
  showAll = false;
  markers = <any>[];
  sliders: any = [
    {
      photo: '/assets/images/shell_ago.jpg',
      photo_mobile: '/assets/images/shell_ago_mobile.jpg',
      link: 'https://shellbox.onelink.me/RT9I/fa6211b1',
    },
    {
      photo: '/assets/images/sb/v1.png',
      photo_mobile: '/assets/images/sb/v1_mobile.png',
      link: 'javascript:void(0)',
    },
  ];
  branches: Branch[] = [];

  public discounts = [
      { numero: 1, descripcion: 'Ingresa a la App' },
      { numero: 2, descripcion: 'Selecciona “Pagar con la App”' },
      { numero: 3, descripcion: 'Escanea el QR' },
      { numero: 4, descripcion: 'Antes de finalizar el pago seleccioná el descuento que desees utilizar' },
      { numero: 5, descripcion: '¡Listo descuento aplicado!' },
  ];

  public points = [
    { numero: 1, descripcion: 'Ingresa a la App' },
    { numero: 2, descripcion: 'Selecciona “Pagar con la App”' },
    { numero: 3, descripcion: 'Escanea el QR' },
    { numero: 4, descripcion: 'Antes de finalizar el pago seleccioná los puntos que desees canjear' },
    { numero: 5, descripcion: '¡Listo!' },
];

  config: SwiperOptions = {
    autoplay: true, // Autoplay option having value in milliseconds
    initialSlide: 0, // Slide Index Starting from 0
    slidesPerView: 1.1, // Slides Visible in Single View Default is 1
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      clickable: true,
    },
    rewind: true,
    centeredSlides: true,
    breakpoints: {
      1280:{
        slidesPerView: 1.12,
      },
    },
    preventClicksPropagation: false,
    speed: 600,
    spaceBetween: 10,
  };
  
  configDesktop: SwiperOptions = {
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      dynamicBullets: true,
      clickable: true,
    },
    slidesPerView: 1.1,
    breakpoints: {
      1280:{
        slidesPerView: 1.12,
      },
    },
    loop: true,
    preventClicksPropagation: false,
    speed: 600,
    centeredSlides: true,
    spaceBetween: 10,
    loopAdditionalSlides: 40,
    initialSlide: 0
  };

  configMobile: SwiperOptions = {
    loop: true,
    autoplay: true,
    initialSlide: 1,
    slidesPerView: 1.1,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      type: 'bullets',
      dynamicBullets: true,
    },
    preventClicksPropagation: false,
    speed: 600,
    centeredSlides: true,
    spaceBetween: 10,
    loopAdditionalSlides: 4
  };

  configPhone: SwiperOptions = {
    initialSlide: 0,
    slidesPerView: 1.4,
    preventClicksPropagation: false,
    speed: 600,
    spaceBetween: 10,
    loopAdditionalSlides: 4,
  };

  desktopImages = [
    { src: '../../../assets/images/phone-1.svg', title: 'Pagá con Shell Box', description: 'Encontrá una estación de servicio adherida. Al momento de pagar, escaneá el código QR. Seleccioná el medio de pago desde la APP. ¡Y listo!' },
    { src: '../../../assets/images/phone-2.png', title: 'Ahorrá con beneficios', description: '¡Con Shell Box accedés a descuentos únicos y sumás puntos desde tu primera compra!' },
    { src: '../../../assets/images/phone-3.png', title: 'Sumá y conjeá puntos', description: 'Con Shell Box podés canjear tus puntos por descuentos en combustibles V-Power, lubricantes y productos de tiendas Shell Select.' }
  ];

  mobileImages = [
    { src: '../../../assets/images/phone-1.svg', title: 'Pagá con Shell Box', text: 'Encontrá una estación de servicio adherida. Al momento de pagar, escaneá el código QR. Seleccioná el medio de pago desde la APP. ¡Y listo!' },
    { src: '../../../assets/images/phone-2.png', title: 'Ahorrá con beneficios', text: '¡Con Shell Box accedés a descuentos únicos y sumás puntos desde tu primera compra!' },
    { src: '../../../assets/images/phone-3.png', title: 'Sumá y conjeá puntos', text: 'Con Shell Box podés canjear tus puntos por descuentos en combustibles V-Power, lubricantes y productos de tiendas Shell Select.' }
  ];

  isMobile: boolean = false;
  isPlayingFirst = false;
  isPlayingSecond = false;

  private swiperInstance: Swiper | null = null;

  desktopGooglePlay = '../../../assets/icon/icon-google-play.svg';
  mobileGooglePlay = '../../../assets/icon/icon-mobile-google-play.svg';
  desktopAppStore = '../../../assets/icon/icon-app-store-.svg';
  mobileAppStore = '../../../assets/icon/icon-app-store-mobile.svg';

  constructor(
    private spinnerService: NgxSpinnerService,
    private locationService: LocationService,
    private benefitsService: BenefitsService,
    private sliderService: SliderService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.isMobile = this.isMobileDevice();
  }

  ngOnInit(): void {
    this.getBenefits();
    this.getSliders();
    this.spinnerService.show();
    this.getLocations();
    this.onResize();
    this.locationService.get().subscribe((data) => {
      this.branches = Array.isArray(data) ? data : [];
    });
    setTimeout(() => {
      this.setMap();
    }, 1000);
  }

  ngAfterViewInit(): void {
    if (this.videoDesktop && this.videoDesktop.nativeElement) {
      this.initVideo(this.videoDesktop.nativeElement);
    }

    if (this.videoMobile && this.videoMobile.nativeElement) {
      this.initVideo(this.videoMobile.nativeElement);
    }
  }

  isMobileDevice(): boolean {
    return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  }
  
  getStoreLink(): string {
    if (/android/i.test(navigator.userAgent)) {
      return 'https://play.google.com/store/apps/details?id=com.raizen.acelera&pli=1';
    } else if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
      return 'https://apps.apple.com/ar/app/shell-box-pague-e-ganhe/id1037433060';
    }
    return '';
  }

  downloadApp() {
    const storeLink = this.getStoreLink();
    if (storeLink) {
      window.location.href = storeLink;
    }
  }

  onSwiper(swiper: Swiper) {
    this.swiperInstance = swiper;
  }

  setSlide(event: any) {
    if (this.swiperInstance) {
      const index = this.swiperInstance.activeIndex;
      this.configPhone = {
        ...this.configPhone,
        centeredSlides: index === 1,
      };
    }
  }
  
  toggleVideo(videoElement: HTMLVideoElement, videoNumber: number) {
    videoElement.muted = false;
    if (videoNumber === 1) {
      if (videoElement.paused) {
        videoElement.play();
        this.isPlayingFirst = true;
      } else {
        videoElement.pause();
        this.isPlayingFirst = false;
      }
    } else if (videoNumber === 2) {
      if (videoElement.paused) {
        videoElement.play();
        this.isPlayingSecond = true;
      } else {
        videoElement.pause();
        this.isPlayingSecond = false;
      }
    }
  }  



  onResize() {
    if (isPlatformBrowser(this.platformId)) {
      this.isMobile = window.innerWidth <= 868;
    }
  }

  private initVideo(video: HTMLVideoElement): void {
    video.muted = true;
    video.play().catch((error) => {
      console.error('Error al reproducir el video:', error);
    });
  }

  isGif(url: string | null | undefined): boolean {
    return url?.toLowerCase().endsWith('.gif') || false;
  }   

  transformVideoLink(url: string): string {
    if (url.includes("youtube.com/watch")) {
      const videoId = url.split("watch?v=")[1].split("&")[0];
      return `https://www.youtube.com/embed/${videoId}?autoplay=1&controls=0&showinfo=0&loop=1&mute=1&playlist=${videoId}`;
    }
    return url;
  }  

  getBenefits() {
    this.benefitsService
      .get()
      .toPromise()
      .then((benefits: any) => {
        this.benefits = benefits;
      });
  }
  getSliders() {
    let tthis = this;
    this.sliderService.getCurrent().subscribe((benefits: any) => {
      tthis.sliders = benefits
        .filter((e: any) => e.slider_Type.name == 'App')
        .sort((a: any, b: any) => a.order - b.order);
    });
  }
  hideSpinner(): void {
    if (this.loading === true) {
      this.spinnerService.hide();
      this.loading = false;
    }
  }
  getMapOptions(): any {
    if (isPlatformBrowser(this.platformId)) {
      const styles: Array<any> = [];

      styles.push({ elementType: 'geometry', stylers: [{ color: '#f5f5f5' }] });
      styles.push({
        elementType: 'labels.icon',
        stylers: [{ visibility: 'off' }],
      });
      styles.push({
        elementType: 'labels.text.fill',
        stylers: [{ color: '#616161' }],
      });
      styles.push({
        elementType: 'labels.text.stroke',
        stylers: [{ color: '#f5f5f5' }],
      });
      styles.push({
        featureType: 'administrative.land_parcel',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#bdbdbd' }],
      });
      styles.push({
        featureType: 'poi',
        elementType: 'geometry',
        stylers: [{ color: '#eeeeee' }],
      });
      styles.push({
        featureType: 'poi',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#757575' }],
      });
      styles.push({
        featureType: 'poi.park',
        elementType: 'geometry',
        stylers: [{ color: '#e5e5e5' }],
      });
      styles.push({
        featureType: 'poi.park',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#9e9e9e' }],
      });
      styles.push({
        featureType: 'road',
        elementType: 'geometry',
        stylers: [{ color: '#ffffff' }],
      });
      styles.push({
        featureType: 'road.arterial',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#757575' }],
      });
      styles.push({
        featureType: 'road.highway',
        elementType: 'geometry',
        stylers: [{ color: '#dadada' }],
      });
      styles.push({
        featureType: 'road.highway',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#616161' }],
      });
      styles.push({
        featureType: 'road.local',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#9e9e9e' }],
      });
      styles.push({
        featureType: 'transit.line',
        elementType: 'geometry',
        stylers: [{ color: '#e5e5e5' }],
      });
      styles.push({
        featureType: 'transit.station',
        elementType: 'geometry',
        stylers: [{ color: '#eeeeee' }],
      });
      styles.push({
        featureType: 'water',
        elementType: 'geometry',
        stylers: [{ color: '#9cc0f9' }],
      });
      styles.push({
        featureType: 'water',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#9cc0f9' }],
      });

      return {
        styles,
        disableDefaultUI: false,
        gestureHandling: 'greedy',
        scrollwheel: false,
        draggable: isPlatformBrowser(this.platformId) ? !('ontouchend' in document) : false,
      };
    }
  }
  setMap(): void {
    if (isPlatformBrowser(this.platformId)) {
      if (this.gmap) {

        const map = new google.maps.Map(this.gmap.nativeElement, {
          disableDefaultUI: false,
          scrollwheel: false,
          gestureHandling: 'greedy',
          draggable: isPlatformBrowser(this.platformId) ? !('ontouchend' in document) : false,
        });
        const mapMobile = new google.maps.Map(this.gmapMobile.nativeElement, {
          disableDefaultUI: false,
          scrollwheel: false,
          gestureHandling: 'greedy',
          draggable: isPlatformBrowser(this.platformId) ? !('ontouchend' in document) : false,
        });
        this.setMapBranches(map);
        this.setMapBranches(mapMobile);
      }
    }
  }

  capitalizeEachWord(text: string): string {
    return text
      .toLowerCase()
      .replace(/\b\w/g, char => char.toUpperCase());
  }

  setMapBranches(map: any) {
    if (isPlatformBrowser(this.platformId)) {
      const bounds = new google.maps.LatLngBounds();

      let infoWindow = new google.maps.InfoWindow();

      this.locations.forEach((item: any) => {
        const icon = '/assets/images/marker-shell-box.svg';
        const position = new google.maps.LatLng(item.latitude, item.longitude);
        const pixelOffset = new google.maps.Size(0, 0);
      
        const formattedAddress = this.capitalizeEachWord(item.address);
        const formattedCity = this.capitalizeEachWord(item.city);
        const formattedProvince = this.capitalizeEachWord(item.province);
      
        const content =
          '<div class="marker-content" style="max-width: 300px; display: flex; flex-direction: column; align-items: center; text-align: center;">' +
            '<div style="display: flex; align-items: center; gap: 10px;">' +
              '<img src="/assets/images/logo-branches.svg"  style="width: 45px;"/>' +
              '<div style="display: flex; align-items: flex-start; gap: 10px; flex-direction: column;">' +
                '<p class="branch-name" style="text-align:start;font-size: 14px; margin: 0;color: #404040;font-size: 14px;font-style: normal;font-weight: 700;line-height: 120%;">' +
                  item.name +
                '</p>' +
                '<p class="marker-name" style="text-align:start;font-size: 14px; margin: 0;font-weight: 400;font-size: 14px;line-height: 16.8px;letter-spacing: 0%;color: #595959;">' +
                  formattedAddress + ', ' + formattedCity + ', ' + formattedProvince +
                '</p>' +
              '</div>' +
            '</div>' +
            '<p class="marker-address" style="margin-top: 12px; justify-content:flex-end; display: flex; width: 100%;margin-bottom: 0;">' +
              '<a style="display: flex; width: 110px; height: 30px; font-weight: 700; font-size: 12px; line-height: 14.4px; text-align: center; justify-content: center; align-items: center; outline: none; color: #FFF; text-decoration: none; border-radius: 4.244px; background: #DD1D21;" target="_blank" href="https://www.google.com/maps/dir//' +
              item.latitude + ',' + item.longitude + '/@' + item.latitude + ',' + item.longitude + ',17z/data=!4m10!1m7!3m6!1s0x0:0x0!2zMzbCsDE1JzU2LjgiTiA5MsKwMzInMzUuNyJX!3b1!8m2!3d36.26577!4d-92.54324!4m1!3e2">' +
                '<i class="fa fa-location-arrow" aria-hidden="true"></i> Cómo llegar' +
              '</a>' +
            '</p>' +
          '</div>';
      
        const marker = new google.maps.Marker({ position, map, icon });
      
        google.maps.event.addListener(marker, 'click', function() {
          infoWindow.setContent(content);
          infoWindow.open(map, marker);
        });
      
        marker.setMap(map);
        this.markers.push(position);
      });

      this.markers.forEach((mark: any) => bounds.extend(mark));
      this.centerMap(map, bounds);
    }
  }
  centerMap(map: any, bounds: any) {
    if (isPlatformBrowser(this.platformId)) {
    if (this.markers.length > 1) map.fitBounds(bounds);
    if (navigator.geolocation) {
      let markers = this.markers;

      navigator.geolocation.getCurrentPosition(function (position) {
        var initialLocation = new google.maps.LatLng(
          position.coords.latitude,
          position.coords.longitude
        );
        map.setCenter(initialLocation);

        var currentLocation = new google.maps.Marker({
          position: initialLocation,
          map,
        });
        currentLocation.setMap(map);

        setBounds();

        function rad(x: any) {
          return (x * Math.PI) / 180;
        }

        var lat = initialLocation.lat();
        var lng = initialLocation.lng();

        function nearestMarker() {
          var R = 6371; // radius of earth in km
          var distances = [];
          var closest = -1;

          for (let i = 0; i < markers.length; i++) {
            var mlat = markers[i].lat();
            var mlng = markers[i].lng();
            var dLat = rad(mlat - lat);
            var dLong = rad(mlng - lng);

            var a =
              Math.sin(dLat / 2) * Math.sin(dLat / 2) +
              Math.cos(rad(lat)) *
                Math.cos(rad(lat)) *
                Math.sin(dLong / 2) *
                Math.sin(dLong / 2);
            var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            var d = R * c;

            distances[i] = d;

            if (closest == -1 || d < distances[closest]) {
              closest = i;
            }
          }

          return markers[closest];
        }

        function setBounds() {
          var closestMarker = nearestMarker();

          var bounds = new google.maps.LatLngBounds();
          bounds.extend(closestMarker);
          bounds.extend(initialLocation);
          map.fitBounds(bounds);
        }
      });
    }
    } else if (this.markers.length > 1) map.fitBounds(bounds);
    else {
      if (isPlatformBrowser(this.platformId)) {
        const position = this.markers[0];
        map.setCenter(position);
        map.setZoom(15);
      }
    }
  }

  getLocations(): void {
    const obs = this.locationService.get().subscribe((data: any) => {
      this.locations = data;
      setTimeout(() => {
        this.hideSpinner();
      }, 2000);
    });
  }
  slideNext() {
    this.swiperHero?.swiperRef.slideNext(100);
  }
  slidePrev() {
    this.swiperHero?.swiperRef.slidePrev(100);
  }
  slideNextMobile(){
    this.swiperHeroMobile?.swiperRef.slideNext();
  }
  slidePrevMobile(){
    this.swiperHeroMobile?.swiperRef.slidePrev();
  }
}
